import { render } from "./BannerDefaultDatabaseSectionCmp.vue?vue&type=template&id=2d5e4afb"
import script from "./BannerDefaultDatabaseSectionCmp.vue?vue&type=script&lang=js"
export * from "./BannerDefaultDatabaseSectionCmp.vue?vue&type=script&lang=js"

import exportComponent from "D:\\working\\MyCi4Vue\\myCi4Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__